/* Cotton exact-size search, isolated preview 2026-10-25. No catalogue writes. */
(() => {
  'use strict';
  const shapeWords = /(?:^|[^\p{L}])(?:yuvarlak|oval|kare|köşe\p{L}*|kose\p{L}*|çap|cap|round|square)(?:$|[^\p{L}])/iu;
  const normalize = value => String(value || '').normalize('NFKC').toLocaleLowerCase('tr-TR').trim();
  function parseMeasure(query) {
    const text = normalize(query);
    if (shapeWords.test(text) || /(?:\d\s*m\s*[²2]|metre|meter)/iu.test(text) || /\b(?:mm|m|inch|feet|ft)\b|inç/iu.test(text)) return null;
    const matches = [...text.matchAll(/(\d+(?:[.,]\d+)?)\s*[x×*]\s*(\d+(?:[.,]\d+)?)(?:\s*cm)?/giu)];
    if (matches.length !== 1) return null;
    const match = matches[0], a = match[1], b = match[2];
    if (!/^[1-9]\d{1,2}$/.test(a) || !/^[1-9]\d{1,2}$/.test(b) || a === b) return null;
    const before = text.slice(0, match.index), after = text.slice(match.index + match[0].length);
    if (/[\p{L}\p{N}.,]$/u.test(before) || /^[\p{L}\p{N}.,]/u.test(after)) return null;
    if (/[x×*]\s*\d|\d\s*[x×*]/u.test(before + ' ' + after)) return null;
    return { width: a, length: b, label: `${a} x ${b} cm` };
  }
  function resolveVariant(query, options, variants, productTitle = '') {
    const measure = parseMeasure(query);
    if (!measure || shapeWords.test(normalize(productTitle))) return { state: 'unchanged' };
    const indexes = options.map((option, i) => normalize(option.name || option) === 'ebat' ? i : -1).filter(i => i >= 0);
    if (indexes.length !== 1) return { state: 'unchanged' };
    const index = indexes[0];
    const matching = variants.filter(variant => {
      const value = normalize(variant.options?.[index]);
      const match = value.match(/^([1-9]\d{1,2})\s*[x×*]\s*([1-9]\d{1,2})(?:\s*cm)?$/u);
      return match && match[1] === measure.width && match[2] === measure.length;
    });
    const available = matching.filter(variant => variant.available === true);
    if (available.length === 1 && /^\d+$/.test(String(available[0].id))) {
      return { state: 'matched', id: String(available[0].id), label: measure.label };
    }
    return { state: available.length > 1 ? 'ambiguous' : matching.length ? 'unavailable' : 'missing', label: measure.label, exactIds: matching.map(variant => String(variant.id)) };
  }
  const api = { parseMeasure, resolveVariant };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (typeof document === 'undefined') return;
  window.CottonSearchIntent = api;
  const selector = '#search-drawer a[data-cotton-size-variants]';
  function reset(anchor) {
    if (anchor.dataset.cottonOriginalHref) anchor.setAttribute('href', anchor.dataset.cottonOriginalHref);
    anchor.removeAttribute('data-cotton-size-state');
    anchor.querySelector('[data-cotton-size-note]')?.remove();
  }
  function apply(anchor) {
    const input = document.querySelector('#search-drawer input[name="q"]');
    const current = input?.value.trim() || '';
    if (anchor.dataset.cottonSizeQuery.trim() !== current) { reset(anchor); return; }
    if (anchor.dataset.cottonAppliedQuery === current) return;
    reset(anchor);
    anchor.dataset.cottonOriginalHref ||= anchor.getAttribute('href');
    let result;
    try {
      result = resolveVariant(current, JSON.parse(anchor.dataset.cottonSizeOptions), JSON.parse(anchor.dataset.cottonSizeVariants), anchor.dataset.cottonSizeTitle);
    } catch (_) { return; }
    anchor.dataset.cottonAppliedQuery = current;
    anchor.dataset.cottonSizeState = result.state;
    if (result.state === 'unchanged') return;
    const url = new URL(anchor.dataset.cottonOriginalHref, location.origin);
    if (result.state === 'matched') {
      url.searchParams.set('variant', result.id);
    } else if (url.searchParams.has('variant') && !result.exactIds.includes(url.searchParams.get('variant'))) {
      // Shopify can suggest a different size for a missing measure. Do not carry that misleading preselection forward.
      url.searchParams.delete('variant');
    }
    anchor.setAttribute('href', url.pathname + url.search + url.hash);
    const note = document.createElement('span');
    note.className = 'text-xs text-subdued';
    note.dataset.cottonSizeNote = '';
    note.textContent = result.state === 'matched' ? `${result.label} ile açılır` :
      result.state === 'unavailable' ? `${result.label} şu an satışa açık değil. Diğer ölçüleri inceleyin.` :
      result.state === 'ambiguous' ? `${result.label} için seçenekleri ürün sayfasında inceleyin.` :
      `${result.label} bu üründe yok. Diğer ölçüleri inceleyin.`;
    anchor.querySelector('.v-stack')?.append(note);
  }
  function sync() { document.querySelectorAll(selector).forEach(apply); }
  function start() {
    const drawer = document.querySelector('#search-drawer');
    if (!drawer) return;
    new MutationObserver(sync).observe(drawer, { childList: true, subtree: true });
    drawer.addEventListener('input', () => {
      drawer.querySelectorAll(selector).forEach(anchor => { reset(anchor); delete anchor.dataset.cottonAppliedQuery; });
      sync();
    }, true);
    drawer.addEventListener('click', event => { const anchor = event.target.closest(selector); if (anchor) apply(anchor); }, true);
    sync();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
